import React from 'react';
import { globalHistory as history } from '@reach/router';
import { Link } from 'gatsby';

const Items = () => {
  const { location } = history;
  let linkClass = 'nav-item text-white';

  return (
    <>
      <a href='https://dionysus.events/' className={linkClass}>
        Home
      </a>
      <a href='https://dionysus.events/projects' className={linkClass}>
        Projects
      </a>
      <a href='/' className={linkClass}>
        Soul Defender
      </a>
      <a href='https://technopicnic.com/' className={linkClass}>
        TechnoPicnic
      </a>
      <a href='https://dionysus.events/people' className={linkClass}>
        People
      </a>
      <Link to='contact' className={linkClass}>
        Contact
      </Link>
    </>
  );
};

export default Items;
